import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const PermissionsContext = createContext();

export function PermissionsProvider({ children }) {
  const [permissionsByRole, setPermissionsByRole] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPermissions() {
      try {
        const res = await axios.get('/api/admin/permissions');
        setPermissionsByRole(res.data);
      } catch (err) {
        console.error('Erreur chargement permissions', err);
      } finally {
        setLoading(false);
      }
    }
    fetchPermissions();
  }, []);

  // Vérifie si le rôle a la permission donnée
  function hasPermission(role, permission) {
    return permissionsByRole[role]?.[permission] || false;
  }

  return (
    <PermissionsContext.Provider value={{ permissionsByRole, hasPermission, loading }}>
      {children}
    </PermissionsContext.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionsContext);
}